namespace MACRAIL.Validation {

export interface IValidator {

    validate(value: string): IValidatorMessage[];
}

export type ValidationStatus = 'warning' | 'error';

export interface IValidatorMessage {
    slug: string;
    status: ValidationStatus;
    message: string;
}

}
